import React, { FC, memo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";

interface ReturnConfirmationHeaderProps {
  readonly onClose: () => void;
}

const ReturnConfirmationHeader: FC<ReturnConfirmationHeaderProps> = ({ onClose }) => {
  const orderReturnTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_RETURN_TITLE,
  });

  return (
    <Header testID="return-confirmation-header">
      <ButtonIconPlaceholder />
      <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
        {orderReturnTitleText}
      </Text>
      <ButtonIcon name="close" testID="close-button-icon" onPress={onClose} />
    </Header>
  );
};

const MemoizedReturnConfirmationHeader = memo(ReturnConfirmationHeader);

export { MemoizedReturnConfirmationHeader as ReturnConfirmationHeader };
